import { isEmpty } from 'lodash';
import { trackError } from 'util/error';
import { getActiveUserId } from 'current/selectors';
import { getMosaicV3FHIFlag } from 'user/selectors';
import { fetchSsurgoGeoJson } from 'imagery/loaders';
import { parseFieldViewLegend, parseFieldViewImagery } from 'imagery/fieldViewParser';
import {
  parseFieldHealthImagery,
  parseV3FieldHealthImagery,
  parseNonSatImagery,
  parseSoilSampleImagery,
  parseSsurgoGeoJson,
  parseSsurgoDataList,
  parseSsurgoV4
} from 'imagery/mosaicImageParser';
import {
  storeFieldViewLegendForImage,
  storeAllFieldViewImagesForField,
  storeAllFieldHealthImagesForField,
  storeAllNonSatImagesForField,
  storeAllSoilSampleImagesForField,
  storeAllSsurgoImagesForField,
  storeAllImportedMapsImagesForField
} from 'imagery';
import {
  snapshotSoilCompositionForActiveScriptId
} from 'scripts';

export const processFieldViewImagery = ({ dispatch, rawImageData }) => {
  // don't let an empty result get to the parser because it throws an error that won't be resolvable,
  // which means groot yield data will never be parsed
  // TODO: make this not terrible
  if (isEmpty(rawImageData)) {
    return Promise.resolve(rawImageData);
  }

  // TODO: Disentangle and/or merge layers and imagery.  See /layers.
  const imagery = parseFieldViewImagery(rawImageData);
  Object.keys(imagery).forEach( (fieldUuid) => {
    dispatch( storeAllFieldViewImagesForField({ fieldUuid, images: imagery[fieldUuid]}) );
  });
  return Promise.resolve(imagery);
};

export const processFieldViewLegend = ({ dispatch, rawLegend, layer, image }) => {
  const legend = parseFieldViewLegend({ rawLegend, layer });
  dispatch(storeFieldViewLegendForImage({
    fieldUuid: image.fieldUuid,
    layer,
    legend,
    overlayUuid: image.overlayUuid
  }));
  return Promise.resolve(legend);
};

export const processFieldHealthImageryForField = ({ dispatch, getState, fieldId, rawImageData }) => {
  const mosaicV3FHIFlag = getMosaicV3FHIFlag(getState());
  const imagery = mosaicV3FHIFlag ? parseV3FieldHealthImagery(rawImageData) : parseFieldHealthImagery(rawImageData);
  dispatch( storeAllFieldHealthImagesForField(fieldId, imagery) );
  return Promise.resolve(imagery);
};

export const processSoilSampleImageryForField = ({ dispatch, fieldId, rawImageData }) => {
  const imagery = parseSoilSampleImagery(rawImageData);
  dispatch( storeAllSoilSampleImagesForField(fieldId, imagery) );
  return Promise.resolve(imagery);
};

export const processNonSatImageryForField = ({ dispatch, fieldId, rawImageData }) => {
  const imagery = parseNonSatImagery(rawImageData);
  dispatch( storeAllNonSatImagesForField(fieldId, imagery) );
  return Promise.resolve(imagery);
};

const processSsurgoGeoJsonForField = ({ dispatch, fieldId, withoutGeoJson, rawGeoJson }) => {
  const parsed = parseSsurgoGeoJson(rawGeoJson, withoutGeoJson);
  dispatch( storeAllSsurgoImagesForField( fieldId, parsed ) );
  dispatch( snapshotSoilCompositionForActiveScriptId() );
  return Promise.resolve(parsed);
};

export const processSsurgoImageryForField = async ({ dispatch, getState, fieldId, rawImageData, useMosaicV4 }) => {
  const state = getState();
  const userId = getActiveUserId(state);
  const withoutGeoJson = useMosaicV4 ? parseSsurgoV4(rawImageData) : parseSsurgoDataList(rawImageData);

  if (withoutGeoJson.url) {
    const rawGeoJson = await fetchSsurgoGeoJson({ url: withoutGeoJson.url, userId });
    return processSsurgoGeoJsonForField({ dispatch, getState, fieldId, withoutGeoJson, rawGeoJson });
  }

  trackError('No SSURGO GeoJson URL found');

  return undefined;
};

export const processImportedMapsGeoJsonForField = ({ dispatch, fieldId, parsedImportedMaps }) => {
  dispatch(storeAllImportedMapsImagesForField(fieldId, parsedImportedMaps));
  return Promise.resolve(parsedImportedMaps);
};
